// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"c28edde4","870":"ebf4ac21"}[chunkId] + ".chunk.js";
};